import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.grey[400],
      fontFamily: theme.typography.fontFamily,
      overflow: "hidden",
      boxSizing: "border-box",
    },

    contentWrapper: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.grey[400],
      overflow: "hidden",
      boxSizing: "border-box",
    },

    topbarWrapper: {
      position: "sticky",
      top: 0,
      zIndex: 20,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.06)",
      flexShrink: 0,
    },

    scrollContent: {
      flex: 1,
      width: "100%",
      overflowY: "scroll",
      overflowX: "hidden",
      padding: 0,
      boxSizing: "border-box",
      backgroundColor: theme.palette.grey[400],

      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.divider} transparent`,

      "&::-webkit-scrollbar": {
        width: 6,
      },

      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
        border: "none",
      },

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: 10,
        border: "none",
        minHeight: 40,
      },

      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.divider,
      },

      "&::-webkit-scrollbar-corner": {
        backgroundColor: "transparent",
      },
    },

    pageContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16,
      opacity: 1,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
    },

    pageBody: {
      width: "100%",
      boxSizing: "border-box",
    },

    detailsPage: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      gap: 16,
      marginTop: 10,
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 24,
      boxSizing: "border-box",
      overflow: "hidden",
    },

    detailsScroll: {
      flex: 1,
      minHeight: 0,
      width: "100%",
      overflowY: "auto",
      overflowX: "hidden",
      boxSizing: "border-box",

      scrollbarWidth: "thin",
      scrollbarColor: `${theme.palette.divider} transparent`,

      "&::-webkit-scrollbar": {
        width: 6,
      },

      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
        border: "none",
      },

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.divider,
        borderRadius: 10,
        border: "none",
        minHeight: 40,
      },

      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: theme.palette.divider,
      },

      "&::-webkit-scrollbar-corner": {
        backgroundColor: "transparent",
      },
    },

    detailsBreadcrumb: {
      width: "100%",
      height: 36,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: 8,
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
      boxSizing: "border-box",
    },

    breadcrumbArrow: {
      fontSize: "18px !important",
      color: theme.palette.text.primary,
      cursor: "pointer",
    },

    breadcrumbIcon: {
      fontSize: "18px !important",
      color: theme.palette.text.primary,
    },

    breadcrumbParent: {
      color: `${theme.palette.text.primary} !important`,
      fontSize: "13px !important",
      fontWeight: "400 !important",
      cursor: "pointer",
      fontFamily: `${theme.typography.fontFamily} !important`,

      "&:hover": {
        color: theme.palette.primary.main,
      },
    },

    breadcrumbSlash: {
      color: `${theme.palette.text.primary} !important`,
      fontSize: "13px !important",
      fontWeight: "400 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
    },

    breadcrumbCurrent: {
      color: `${theme.palette.secondary.main} !important`,
      fontSize: "13px !important",
      fontWeight: "500 !important",
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
  })
);